<template>
  <!--<vue-friendly-iframe id="iframe-footer" :src="`${publicPath}/static/html/com/footer.html`"></vue-friendly-iframe>-->
  <div id="footer" class="footer">
    <div class="footer_top"></div>
    <div class="footer_bottom">
      <div class="row" style="width:100%;">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="row">
            <div class="paddingR-0 paddingL-0 col-md-6">
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-8 align paddingR-0 paddingL-0 margin-right-a margin-left-a">
                  <span class="informacion">
                    <a
                      class="pl-0"
                      :href="`${footerVars.informacion.url}`"
                    >{{footerVars.informacion.text}}</a>
                  </span>
                </div>
                <div class="col-md-3 align paddingR-0 paddingL-20">
                  <span class="iravtr">
                    <a :href="`${footerVars.iravtr.url}`">
                      {{footerVars.iravtr.text}}
                      <img src="../../public/static/images/link_ext.png" />
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 paddingL-0">
              <div class="row">
                <div class="col-md-1 paddingL-0 paddingR-0"></div>
                <div class="col-md-3 paddingR-0 paddingL-0">
                  <span class="icons">
                    <a :href="`${footerVars.social.facebook}`">
                      <img src="../../public/static/images/icon-facebook.png" />
                    </a>
                    <a :href="`${footerVars.social.twitter}`">
                      <img src="../../public/static/images/icon-twitter.png" />
                    </a>
                    <a :href="`${footerVars.social.youtube}`">
                      <img src="../../public/static/images/icon-youtube.png" />
                    </a>
                  </span>
                </div>
                <div
                  class="col-md-8 align paddingR-0 paddingL-0 margin-right-a margin-left-a margin-left-15"
                >
                  <span class="links">
                    <a
                      :href="`${footerVars.links.condiciones.url}`"
                    >{{footerVars.links.condiciones.text}} |</a>
                    <a
                      :href="`${footerVars.links.privacidad.url}`"
                    >{{footerVars.links.privacidad.text}} |</a>
                    <a :href="`${footerVars.links.vtr.url}`">{{year}} {{footerVars.links.vtr.text}}</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import * as constants from "@/common/constants";
export default {
  name: "Footer",
  data() {
    return {
      publicPath: config.url.base,
      vars: config.footer
    };
  },
  computed: {
    footerVars() {
      const path =
        constants.varsFooterHeader[config.env][
          this.$store.getters.billingInfo.paymentChannel
        ] != undefined
          ? constants.varsFooterHeader[config.env][
              this.$store.getters.billingInfo.paymentChannel
            ]
          : constants.varsFooterHeader[config.env]["vtr_com"];
      if (path[this.$store.getters.billingInfo.context] != undefined) {
        return path[this.$store.getters.billingInfo.context];
      } else {
        return path["normal"];
      }
    },
    year() {
      let dt = new Date();
      return dt.getFullYear();
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss">
body {
  margin-bottom: 718px;
}
#iframe-footer {
  padding-top: 100px;
  & > iframe {
    position: absolute;
    bottom: 0;
    width: 100%;
    border: 0;
    display: inline-block;
    height: 717px;
  }
}
@media (max-width: 768px) {
  body {
    margin-bottom: 164px;
  }
  #iframe-footer > iframe {
    height: 165px;
  }
  .margin-left-a {
    margin-left: auto !important;
  }
  .margin-right-a {
    margin-right: auto !important;
  }
}
/* header y footer */
.footer {
  height: 77px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.footer a:link,
a:hover,
a:active,
a:visited {
  text-decoration: none;
}

.footer div.footer_top {
  background-image: url("../../public/static/images/bottom.png");
  height: 6px;
}

.footer div.footer_bottom {
  padding-top: 22px;
  padding-bottom: 10px;
  background-color: #000000;
  height: 100%;
}
.footer span.informacion > a {
  width: 292px;
  height: 45px;
  color: #ffffff;
  font-family: "Conv_NeoSansStd Regular";
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  padding-left: 25px;
}
.footer span.iravtr > a {
  width: 69px;
  height: 20px;
  color: #ff2c83;
  font-family: "Conv_NeoSansStd Regular";
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
.footer span.icons {
}
.footer span.links > a {
  margin-top: 31px;
  margin-bottom: 32px;
  width: 409px;
  height: 14px;
  color: #a1a1a1;
  font-family: "Conv_NeoSansStd Regular";
  font-size: 12px;
  font-weight: 400;
}

.footer div.align {
  padding-top: 8px;
}
@media (max-width: 1440px) {
  .paddingL-0 {
    padding-left: 0px !important;
  }
  .paddingL-20 {
    padding-left: 20px !important;
  }
  .paddingR-0 {
    padding-right: 0px !important;
  }
}
@media (max-width: 1024px) {
  .margin-left-15 {
    margin-left: 15px;
  }
  .col-md-8 {
    max-width: 60% !important;
  }
  .footer div.align {
    padding-top: 0px !important;
  }
  .col-md-3 {
    padding-left: 0px !important;
  }
}
@media (max-width: 768px) {
  .footer {
    height: 257px;
    position: relative;
    margin-top: 70px !important;
  }

  .footer span {
    display: block;
    text-align: center;
  }

  .footer div.footer_bottom {
    height: 100%;
  }

  .footer span.icons {
    margin-left: auto;
    margin-right: auto;
  }

  .footer span.informacion {
    padding-top: 10px;
  }

  .footer span.iravtr {
    padding-top: 15px;
  }

  .footer span.icons {
    padding-top: 40px;
  }

  .footer span.links {
    padding-top: 25px;
  }

  .footer span.links > a {
    font-size: 9px;
  }

  .footer div.align {
    padding-top: auto;
  }
}
</style>
